import React from 'react';
import { Grid, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, FormHelperText, Button, ListSubheader } from '@mui/material';
import { doctorGroups } from '../constants/options';

const BeforePatientLeaves = ({ formData, setFormData, errors, setErrors, handleChange, handleCheckboxChange, handleBlur, handleSignatureOpen }) => {
  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/;
    const { name, value } = e.target;
    if (value === '' || regex.test(value)) {
      setFormData(prev => ({ ...prev, [name]: value }));
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
    }
  };

  return (
    <>
      <FormControlLabel 
        control={<Checkbox checked={formData.nurse_verbal_confirmation} onChange={handleChange} name="nurse_verbal_confirmation" />} 
        label="Nurse verbally confirms with the team" 
      />
      
      <hr className="my-3" />
      <FormControlLabel 
        control={<Checkbox checked={formData.procedure_recorded} onChange={handleChange} name="procedure_recorded" />} 
        label="The name of the procedure recorded" 
      />
      
      <hr className="my-3" />
      <div className="font-semibold mb-1">Instrument, sponge and needle count:</div>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.instrument_sponge_needle_count_checked === "yes"}
            onChange={(event) => handleCheckboxChange(event, "yes", "instrument_sponge_needle_count_checked")}
            name="instrument_sponge_needle_count_checked_yes"
          />
        }
        label="Checked & Recorded"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.instrument_sponge_needle_count_checked === "no"}
            onChange={(event) => handleCheckboxChange(event, "no", "instrument_sponge_needle_count_checked")}
            name="instrument_sponge_needle_count_checked_no"
          />
        }
        label="NA"
      />

      <hr className="my-2" />
      <FormControlLabel control={<Checkbox checked={formData.specimen_labelled} onChange={handleChange} name="specimen_labelled" />} label="Has the specimen been labeled?" />
      <br />
      <FormControlLabel control={<Checkbox checked={formData.equipment_problem} onChange={handleChange} name="equipment_problem" />} label="Whether there are any equipment problems to be addressed?" />
      
      <hr className="my-3" />
      <FormControlLabel 
        control={<Checkbox checked={formData.recovery_concerns} onChange={handleChange} name="recovery_concerns" />} 
        label="Surgeon, anesthesia professional & nurse review the key concerns for recovery and management of patient" 
      />
      
      <div className="font-semibold mt-3 mb-1">Post-Operative instructions:</div>
      <FormControlLabel control={<Checkbox checked={formData.post_op_instruction_by_surgeon} onChange={handleChange} name="post_op_instruction_by_surgeon" />} label="By Surgeon" />
      <FormControlLabel control={<Checkbox checked={formData.post_op_instruction_by_anesthesiologist} onChange={handleChange} name="post_op_instruction_by_anesthesiologist" />} label="By Anesthesiologist" />
      <br />
      <FormControlLabel control={<Checkbox checked={formData.recovery_charting_done} onChange={handleChange} name="recovery_charting_done" />} label="Recovery charting done" />

      <hr className="my-3" />
      <div className="font-bold text-center mt-4">SURGEON</div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth sx={{ marginTop: 1 }}>
            <InputLabel id="surgeon_name-label">Name (Surgeon)</InputLabel>
            <Select
              labelId="surgeon_name-label"
              name="surgeon_name"
              value={formData.surgeon_name || ""}
              onChange={handleNameChange}
              onBlur={handleBlur}
              error={!!errors.surgeon_name}
              label="Name (Surgeon)"
            >
              <MenuItem value="">
                <em>Select Doctor</em>
              </MenuItem>
              {Object.entries(doctorGroups).map(([specialty, doctors]) => [
                <ListSubheader key={specialty}>{specialty}</ListSubheader>,
                doctors.map((doctor, idx) => (
                  <MenuItem key={`${specialty}-${idx}`} value={doctor}>
                    {doctor}
                  </MenuItem>
                ))
              ])}
            </Select>
            {errors.surgeon_name && <FormHelperText>{errors.surgeon_name}</FormHelperText>}
          </FormControl>

          <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen("surgeon_signature")}> 
            Sign Here 
          </Button>
          {formData.surgeon_signature && (
            <img 
              src={`data:image/png;base64,${formData.surgeon_signature}`} 
              alt="Signature" 
              style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px', objectFit: 'contain' }} 
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default BeforePatientLeaves;
